import is from 'is_js';
import { buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';
import defaultMembersSortComparator from './sort';

const buildMembersUrl = (groupId) => buildUrl(`/groups/${groupId}/members`);

export function getMembersByGroup(state, groupId) {
  return state.get('rootReducer').get('groupMembers')
    .filter((member) => member.groupId === groupId)
    .toList()
    .sort(defaultMembersSortComparator);
}

export function getDefaultMember(state, groupId) {
  const members = getMembersByGroup(state, groupId);
  if (is.existy(members) && members.size !== 0) {
    return members.get(0);
  }
}

export function getMemberById(state, id) {
  return state.get('rootReducer').get('groupMembers').get(id);
}

export function isLoadingMembers(state, groupId) {
  const callState = ApiCall.find(state, { method: 'GET', url: buildMembersUrl(groupId) });
  return ApiCall.State.isValue(callState) && ApiCall.State.isLoading(callState);
}



// WEBPACK FOOTER //
// ./data/GroupMembers/accessors.js